export default {
    props: ['websiteUrl', 'fitter'],
    data() {
        return {
            customOptions: {
                type: 'lightbox',
                inject: 'onload',
                iframeIntegrationId: 'libraryObject',
                iframeHelperURL: this.websiteUrl +  '/helper.html',
                iframeBaseURL: this.websiteUrl,
                target: 'payment-fancybox',
                trigger: 'payment-submit',
                accessibility: true,
                debug: false,
                language: 'en',
                country: 'gb',
                preferredPaymentMethod: 'VISA-SSL',
                successURL: this.websiteUrl +'/order-processing',
                cancelURL: this.websiteUrl +'/booking-details',
                failureURL: this.websiteUrl +'/order-failure',
                pendingURL: this.websiteUrl +'/order-pending',
                errorURL: this.websiteUrl +'/error'
            },
            formData: new FormData(),
            updatedBasket: this.basket,
            serviceData: [],
            fitterServices: this.fitter.services ?? [],
            registration: this.sessionReg != null ? this.sessionReg : '',
            postcode: this.sessionPostcode != null ? this.sessionPostcode : '',
            serviceModalOpen: false,
            billingAddresses: this.addresses,
            shippingAddresses: this.addresses,
            inputAddressManually: false,
            inputShippingAddressManually: false,
            //Shipping fields,
            same_as_billing: (this.basket?.home_delivery == 1 || this.fitter?.mobile == 1) ? true : false,
            //Order fields
            agreed_conditions: false,
            paymentMethod: 'card',
            validateAppDate: this.basket?.home_delivery == 0,
            validateAppTime: (this.basket?.home_delivery == 0 && (this.fitter?.mobile == 0 || this.fitter?.cal_account_number == 'CALTOTD')),
            customerData: {}
        };
    },
    mounted() {
        this.emitter.on('refreshBasket', data => {
            this.refreshBasket();
        });

        this.emitter.on('updateBasket', data => {
            this.updatedBasket = data;
        });

        this.emitter.on('refreshServices', data => {
            this.refreshServices(data);
        });
    },
    methods: {
        onCheckoutSubmit(values) {
            this.emitter.emit('isLoading', true);

            //Track Upsell modal opening
            if(typeof(this.$gtag) !== 'undefined') {
                this.$gtag.event('Checkout Submit', {
                    'event_category' : 'Checkout',
                    'event_label' : 'Complete Order Button Clicked'
                });
            }
            else {
                console.log('gtag not loaded');
            }

            let vm = this;

            //Loop through posted values and append to formData
            _.forEach(values, function(param, key) {

                if(key == 'address' && vm.inputAddressManually == true) {
                    return;
                }
                
                if (key == 'shipping_address' && vm.inputShippingAddressManually == true) {
                    return;
                }

                if(param) {
                    vm.formData.append(key, param);
                }
            });
            
            //Store values for later use with Squeezely tracking.. <(^.^)>
            vm.customerData.email = values.email;
            vm.customerData.firstname = values.forename;
            vm.customerData.lastname = values.surname;
            vm.customerData.phone = values.telephone;
            vm.customerData.postcode = values.postcode;

            //Store values for later use with Squeezely tracking.. <(^.^)>
            vm.customerData.email = values.email;
            vm.customerData.firstname = values.forename;
            vm.customerData.lastname = values.surname;
            vm.customerData.phone = values.telephone;
            vm.customerData.postcode = values.postcode;

            vm.formData.append('same_as_billing', (this.same_as_billing == true ? 1 : 0));
            
            if(this.updatedBasket.home_delivery == false) {
                //Check for services to upsell to customer
                axios.post('/ajax/service_modal_window')
                .then(response => {
                    //Check that the returned service should launch a modal, and that this service isn't already in the basket
                    if(response.data.show_modal && vm.serviceInBasket == false) {
                        vm.emitter.emit('isLoading', false);

                        vm.serviceData = response.data.service;
                        vm.serviceModalOpen = true;
                        
                        //Track Upsell modal opening
                        if(typeof(vm.$gtag) !== 'undefined') {
                            vm.$gtag.event('Service Modal', {
                                'event_category' : 'Checkout',
                                'event_label' : 'Service Modal Opened'
                            });
                        }
                        else {
                            console.log('gtag not loaded');
                        }

                        return;
                    }
                    //No services to upsell found, proceed to payment
                    else {
                        this.processOrder();
                    }
                })
                .catch(error => {
                    console.error("There was an error!", error);
                });
            }
            else {
                this.processOrder();
            }
        },
        handleServiceUpsell(serviceCode, quantity) {
            let vm = this;
            
            var basketFormData = new FormData();
            basketFormData.append('st_code', serviceCode);
            basketFormData.append('quantity', quantity);

            if(serviceCode != null || typeof(serviceCode) != 'undefined') {
                axios.post('/ajax/add_to_basket', basketFormData)
                .then(response => {
                    if(response.data.basket_updated == true)
                    {
                        vm.updatedBasket = response.data.basket;
                        this.processOrder();
                    }
                })
                .catch(error => {
                    console.error("There was an error!", error);
                });
            }
            else {
                this.processOrder();
            }

            vm.serviceModalOpen = false;
        },
        processOrder: function() {
            //Toggle global loading component
            this.emitter.emit('isLoading', true);

            let vm = this;
            axios.post('/ajax/process_order', vm.formData)
            .then(response => {
                //Toggle global loading component
                this.emitter.emit('isLoading', false);

                if(response.data.response.success == true)
                {
                    //Track Upsell modal opening
                    if(typeof(vm.$gtag) !== 'undefined') {
                        vm.$gtag.event('Payment Modal', {
                            'event_category' : 'Payment',
                            'event_label' : 'Payment Modal Opened'
                        });
                    }
                    else {
                        console.log('gtag not loaded');
                    }

                    /* Squeezely PrePurchase */
                    vm.emitter.emit('updateSqueezely', {
                        "event" : "PrePurchase",
                        "email" : vm.customerData.email,
                        "firstname" : vm.customerData.firstname,
                        "lastname" : vm.customerData.lastname,
                        "phone" : vm.customerData.telephone,
                        "postcode" : vm.customerData.postcode,
                        "currency" : "GBP",
                        "language" : "en-GB",
                        "products" : vm.stCodes
                    });

                    if (typeof response.data.full_page_redirect != 'undefined' && response.data.full_page_redirect == true)
                    {
                        window.location.href = response.data.url;
                    }
                    else
                    {
                        vm.initializeHostedPaymentPageContent(response.data.url);
                    }
                }
                else
                {
                    if(typeof response.data.redirect != 'undefined') {
                        window.location.replace(response.data.redirect);
                        return;
                    }

                    if (response.data.errors !== 'undefined')
                    {
                        alert(response.data.errors);
                    }
                    else
                    {
                        alert('An unknown error has occurred.');
                    }
                }
            })
            .catch(error => {
                console.error("There was an error!", error);
            });
        },
        initializeHostedPaymentPageContent: function(payment_url)
        {
            this.customOptions.url = payment_url;

            var libraryObject = new WPCL.Library();

            libraryObject.setup(this.customOptions);

            dispatchEvent(new CustomEvent('load'));
    
            this.$refs.paymentSubmit.click();
        },
        refreshBasket() {
            let vm = this;
            axios('/ajax/get_basket/1')
                .then(response => {
                    if(typeof(response.data.basket) != 'undefined')
                    {
                        vm.updatedBasket = response.data.basket;
                    }
                })
                .catch(error => {
                    console.error("There was an error!", error);
                });
        },
        refreshServices(services) {
            this.fitterServices['available'] = services['available'];
            this.fitterServices['unavailable'] = services['unavailable'];
        },
        async postcodeLookup(postcode, billing) {
            let vm = this;
            //There is no point in trying to search for geolocation on less than 3 characters
            if(postcode.length >= 3) {
                const lookup = await axios.get('/ajax/postcode_addresses/'+ postcode);

                if(lookup.length != 0) {
                    if(billing == true) {
                        vm.billingAddresses = lookup.data.response;
                    }
                    else {
                        vm.shippingAddresses = lookup.data.response;
                    }
                }
            }
        }
    },
    computed: {
        serviceInBasket() {
            if(this.updatedBasket.products.length > 0) {
                let query = this.updatedBasket.products.filter((basket_product) => {
                    return (basket_product.st_code == this.serviceData.code);
                });

                return query.length > 0 ? true : false;
            }
        },
        stCodes() {
            let stCodes = [];
            let product;

            if(this.updatedBasket.products.length > 0) {
                this.updatedBasket.products.forEach(function (basketProduct) {
                    product = {
                        'id': basketProduct.st_code
                    };
                    stCodes.push(product);
                });
            }

            return stCodes;
        }
    }
};